const conutryarr = [
  { sty: 'title', content: 'Africa' },
  { sty: 'item', content: 'ZA', src: 'SOUTHAFRICA', money: 'ZAR' },
  { sty: 'title', content: 'America' },
  { sty: 'item', content: 'US', src: 'usa', money: 'USD' },
  { sty: 'item', content: 'CA', src: 'flag_Canada', money: 'CAD' },
  { sty: 'item', content: 'BR', src: 'flag_Brazil', money: 'BRL' },
  { sty: 'title', content: 'Asia' },
  { sty: 'item', content: 'HK', src: 'HONGKONG', money: 'HKD' },
  { sty: 'item', content: 'JP', src: 'japan', money: 'JPY' },
  { sty: 'item', content: 'KR', src: 'korea', money: 'KRW' },
  { sty: 'item', content: 'SG', src: 'SINGAPORE', money: 'SGD' },
  { sty: 'item', content: 'SA', src: 'st', money: 'SAR' },
  { sty: 'item', content: 'IQ', src: 'ylk', money: 'USD' },
  { sty: 'item', content: 'TW', src: '', money: 'TWD' },
  { sty: 'item', content: 'TH', src: 'THAILAND', money: 'THB' },
  { sty: 'item', content: 'AE', src: 'flag_United-Arab-Emirates', money: 'AED' },
  { sty: 'item', content: 'KW', src: 'flag_Kuwait', money: 'USD' },
  { sty: 'item', content: 'MY', src: 'flag_Malaysia', money: 'MYR' },
  { sty: 'item', content: 'PH', src: 'flag_Philippines', money: 'PHP' },
  { sty: 'item', content: 'TR', src: 'flag_Turkey', money: 'TRY' },
  { sty: 'item', content: 'QA', src: 'flag_Qatar', money: 'QAR' },
  { sty: 'item', content: 'IN', src: 'flag_India', money: 'INR' },
  { sty: 'item', content: 'ID', src: 'flag_Indonesia', money: 'IDR' },
  { sty: 'title', content: 'Europe' },
  { sty: 'item', content: 'DE', src: 'g', money: 'EUR' },
  { sty: 'item', content: 'PT', src: 'pty', money: 'EUR' },
  { sty: 'item', content: 'RU', src: 'rus', money: 'RUB' },
  { sty: 'item', content: 'ES', src: 'xb', money: 'EUR' },
  { sty: 'item', content: 'CH', src: 'SWITZERLAND', money: 'CHF' },
  { sty: 'item', content: 'GB', src: 'en', money: 'GBP' },
  { sty: 'item', content: 'IT', src: 'flag_Italy', money: 'EUR' },
  { sty: 'item', content: 'NL', src: 'flag_Netherlands', money: 'EUR' },
  { sty: 'item', content: 'PL', src: 'flag_Poland', money: 'PLN' },
  { sty: 'item', content: 'NO', src: 'flag_Norway', money: 'NOK' },
  { sty: 'item', content: 'UA', src: 'flag_Ukraine', money: 'UAH' },
  { sty: 'item', content: 'SE', src: 'flag_Sweden', money: 'SEK' },
  { sty: 'item', content: 'RS', src: 'flag_Serbia', money: 'RSD' },
  { sty: 'item', content: 'RO', src: 'flag_Romania', money: 'RON' },
  { sty: 'item', content: 'FR', src: 'flag_France', money: 'EUR' },
  { sty: 'item', content: 'FI', src: 'flag_Finland', money: 'EUR' },
  { sty: 'item', content: 'DK', src: 'flag_Denmark', money: 'DKK' },
  { sty: 'item', content: 'BE', src: 'flag_Belgium', money: 'EUR' },
  { sty: 'item', content: 'AT', src: 'flag_Austria', money: 'EUR' },
  { sty: 'title', content: 'Oceania' },
  { sty: 'item', content: 'AU', src: 'AUSTRALIA', money: 'AUD' },
  { sty: 'item', content: 'NZ', src: 'flag_New-Zealand', money: 'NZD' },
  { sty: 'item', content: 'VI', src: 'vi', money: 'VND' },
]
// const conutryarr =  [
//   {'sty':'title','content':'Africa'},
//   {'sty':'item','content':'ZA',src:'SOUTHAFRICA',money:'USD'},
//   {'sty':'title','content':'America'},
//   {'sty':'item','content':'US',src:'usa',money:'USD'},
//   {'sty':'title','content':'Asia'},
//   {'sty':'item','content':'HK',src:'HONGKONG',money:'USD'},
//   {'sty':'item','content':'JP',src:'japan',money:'JPY'},
//   {'sty':'item','content':'KR',src:'korea',money:'KRW'},
//   {'sty':'item','content':'SG',src:'SINGAPORE',money:'USD'},
//   {'sty':'item','content':'SA',src:'st',money:'SAR'},
//   {'sty':'item','content':'IQ',src:'ylk',money:'USD'},
//   {'sty':'item','content':'TW',src:'',money:'TWD'},
//   {'sty':'item','content':'TH',src:'THAILAND',money:'USD'},
//   {'sty':'item','content':'AE',src:'UNITEDEMIRATES',money:'USD'},
//   {'sty':'title','content':'Europe'},
//   {'sty':'item','content':'DE',src:'g',money:'EUR'},
//   {'sty':'item','content':'PT',src:'pty',money:'EUR'},
//   // {'sty':'item','content':'RU',src:'rus',money:'RUB'},
//   {'sty':'item','content':'ES',src:'xb',money:'EUR'},
//   {'sty':'item','content':'CH',src:'SWITZERLAND',money:'USD'},
//   {'sty':'item','content':'GB',src:'en',money:'GBP'},
//   {'sty':'title','content':'Oceania'},
//   {'sty':'item','content':'AU',src:'AUSTRALIA',money:'AUD'},
// ];
export default conutryarr
